import { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Form from 'react-bootstrap/Form';
import Sidebar from '../components/Sidebar'
import { IMAGE_URL } from '../API';
import { FiEdit } from "react-icons/fi";
import { HiOutlineMail } from "react-icons/hi";
import { ProfileContext } from '../context/ProfileContext';
import Avtar from '../Assets/Images/Avatar.svg'

function Profile() {
  const { personalInfo, viewProfile } = useContext(ProfileContext)
  useEffect(() => { viewProfile(); }, []);

  return (
    <>
      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section>
              <div className="comn-back-white">
                <div className="comm_form_border_box">
                  <section className="back-comn-img">
                    <div className="profile_main_page edit-profile-amin">
                      <Form>
                        <div className="my-profile-left d-flex employer_logo_edit">
                          <div className="upper-name-profile-all">
                            <div className="profile-pic">
                              <Form.Control id="file" type="file" name="file" />
                              <figure className="profile-img-edit">
                                <img src={personalInfo?.image ? IMAGE_URL + personalInfo?.image : Avtar} alt="Profile Preview" />
                              </figure>
                            </div>
                            <div className="name-all">
                              <h6>{personalInfo?.name}</h6>
                              <p><HiOutlineMail className="me-2" />{personalInfo?.email}</p>
                            </div>
                          </div>
                          <div className="pair-btns-comn d-flex align-items-center gap-3">
                            <Link to="/edit-profile" className="comn-btn-pair edit_profile_btn"> <FiEdit />Edit Profile</Link>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </section>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  )
}

export default Profile